import { useEffect, useState, Fragment } from "react";
import Pagination from "./Pagination";
import Accordion from "react-bootstrap/Accordion";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { fetchcompetition, STATUSES } from "../redux/getReducer/getCompetition";
import Animate from "../assets/loader.json";
import Lottie from "lottie-react";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'

import RaceSectionTimer from "../Components/Reuseable/RaceSectionTimer";
import Footer from "../Components/Reuseable/Footer";
import CoptRight from "../Components/Reuseable/Copyrights";
import Justsponsor from "./justsponser";

// Import your custom icon/image
import horseIcon from "../assets/horse (2).png";
import headerHorse from "../assets/data1/image 4.png";
import RecentActivitiesCard from "../Components/Home/Components/RecentActivitiesCard";
// Import custom CSS with new- prefix
// import "./CompetitionNew.css"; 

const Competition = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [state, setState] = useState(false);
  const { data: competitionRes, status } = useSelector(
    (state) => state.competition
  );
  const competitionList = competitionRes?.data || [];
  const totalcountdata = competitionRes?.totalcount || 0;
  const totalpagesdata = competitionRes?.totalPages || 1;
  const [userIsDesktop, setUserIsDesktop] = useState(true);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);

  // Pagination logic
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  useEffect(() => {
    dispatch(fetchcompetition({ currentPage, postsPerPage }));
  }, [dispatch, currentPage, postsPerPage]);

  useEffect(() => {
    window.innerWidth > 840 ? setUserIsDesktop(true) : setUserIsDesktop(false);
  }, [userIsDesktop]);

  if (status === STATUSES.LOADING) {
    return (
      <div className="new-loader-container">
        <Lottie animationData={Animate} loop={true} className="Lottie compLottie" />
      </div>
    );
  }

  if (status === STATUSES.ERROR) {
    return <h2 className="new-error-msg">Something went wrong!</h2>;
  }

  const cookiedata = Cookies.get("i18next");

  function HandleJockey(id, compId) {
    if (userIsDesktop === true) {
      navigate("/race-detail?" + id);
    } else {
      navigate("/racedetails?" + id);
    }
  }

  return (
    <Fragment>
      <div class="new-competition-page-scope">
        {/* Top Banner Section */}
        <div className="common-page-banner">
          <h1>{t("Competition Overview")}</h1>
        </div>

        <div className="container new-comp-main-layout">
          <div className="row new-layout-70-30">
            {/* Left Side: Competition Card */}
            <div className="col-lg-9">
              <div className="new-white-card">
                <div className="new-card-header">
                  <h3>{t("COMPETITION")}</h3>
                  <img src={headerHorse} alt="logo" className="new-small-horse-logo" style={{ margin: '0 0 0 10px' }} />
                </div>

                <div className="new-accordion-container">
                  {status === STATUSES.LOADING ? (
                    <SkeletonTheme baseColor="#eee" highlightColor="#f5f5f5">
                      <p className="sk-class"><Skeleton count={3} height={60} style={{ marginBottom: '10px' }} /></p>
                    </SkeletonTheme>
                  ) : !competitionList || competitionList?.length === 0 ? (
                    <p style={{ textAlign: 'center', padding: '40px', color: '#999' }}>{t("No Competition Available")}</p>
                  ) : (
                    competitionList.map((item, index) => (
                      item.CompetitionDataOfRaceV2.length !== 0 && (
                        <Accordion key={item._id} className="new-custom-accordion" defaultActiveKey={index === 0 ? item._id : null}>
                          <Accordion.Item eventKey={item._id} className="new-acc-item">
                            <Accordion.Header className="new-acc-header">
                              <div className="new-acc-header-flex">
                                <div className="new-acc-left-info">
                                  <span className="new-loc-name">
                                    {cookiedata === "en" ? (
                                      <>
                                        {item.NameEn.split(/-/).slice(0, 1)}
                                        <span className="new-loc-years">
                                          {item.NameEn.split(/-/).slice(1).join(' ').replace(/(\d{4})\s(\d{4})/, ' $1 TO $2')}
                                        </span>
                                      </>
                                    ) : item.NameAr}
                                  </span>
                                </div>
                                <div className="new-acc-right-info">
                                  <span className="new-race-count">
                                    {t("RACES")} {item.CompetitionDataOfRaceV2.length}
                                  </span>
                                </div>
                              </div>
                            </Accordion.Header>

                            <Accordion.Body className="new-acc-body custom-scrollbar" style={{ height: "500px" }}>
                              {item.CompetitionDataOfRaceV2.map((data, index) => (
                                <div className="new-race-row" key={index} onClick={() => HandleJockey(data.Race || data.RaceDataOfCompetitionV2?._id, item._id)}>
                                  <div className="new-race-name">
                                    {data.RaceDataOfCompetitionV2?.RaceNameModelData ? (
                                      cookiedata === "en" ? data.RaceDataOfCompetitionV2.RaceNameModelData.NameEn : data.RaceDataOfCompetitionV2.RaceNameModelData.NameAr
                                    ) : "-"}
                                  </div>

                                  <div className="new-race-time-info">
                                    <img src={horseIcon} alt="horse" className="new-inner-horse-img" />
                                    <div className="new-at-time-box">
                                      <span className="new-at-text">At</span>
                                      <span className="new-actual-time">
                                        <RaceSectionTimer
                                          timer={data.RaceDataOfCompetitionV2?.TimeRemaining || "00:00:00"}
                                          starttime={data.RaceDataOfCompetitionV2?.StartTime}
                                          state={state}
                                          setState={setState}
                                        />
                                      </span>
                                    </div>
                                  </div>

                                  <div className="new-view-btn">
                                    <span>{t("View")}</span>
                                  </div>
                                </div>
                              ))}
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      )
                    ))
                  )}
                </div>
                {competitionList && competitionList.length > 0 && totalpagesdata > 1 && (
                  <div className="new-trainer-pagination-container" style={{ marginTop: '20px', display: 'flex', justifyContent: 'center' }}>
                    <Pagination postsPerPage={postsPerPage} totalPosts={totalcountdata} paginate={paginate} currentPage={currentPage} TotalPages={totalpagesdata} />
                  </div>
                )}
              </div>
            </div>

            {/* Right Side: Latest Updates */}
            <div className="col-lg-3">
              <div className="new-updates-section">

                <div style={{ marginTop: '20px' }}>
                  <RecentActivitiesCard />
                </div>
                <div className="new-just-sponsor-wrapper">
                  {/* <Justsponsor /> */}
                </div>

                {/* Translucent Horse Logo Background effect */}
                {/* <div className="new-bg-horse-watermark"></div> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <CoptRight />
    </Fragment>
  )
}

export default Competition;
